if (!customElements.get('sticky-tabs')) {
	class StickyTabs extends HTMLElement {
		constructor() {
			super();
		}
		connectedCallback() {
			const sectionId = this.dataset.sectionId;
			window.addEventListener('scroll', function() {
				const sections = document.querySelectorAll('.sticky-content--element[id]');
				const navbar = document.getElementById('sticky-tabs');
				
				sections.forEach(section => {
					const top = section.getBoundingClientRect().top;
					if (top >= 0 && top <= 180) {
						const allTabs = navbar.querySelectorAll('li');
						allTabs.forEach(tab => {
							tab.classList.remove('active');
						});
						const id = section.getAttribute('id');
						const targetTab = navbar.querySelector('li[data-sticky-tag="' + id + '"]');
						targetTab.classList.add('active');
					}
				});
				
				const stickyTabs = document.querySelectorAll('.sticky-tab');
				const lastTab = stickyTabs[stickyTabs.length - 1];
				const lastSection = document.querySelector(`#${lastTab.dataset.stickyTag}`);
				const stickyEle = document.querySelector(`#shopify-section-${sectionId}`);
				const lastSectionBottom = lastSection.getBoundingClientRect().bottom;
				
				if (lastSectionBottom < 180) {
					const computedStyle = window.getComputedStyle(stickyEle);
					const topValue = parseInt(computedStyle.getPropertyValue('top'));
					stickyEle.style.top = lastSectionBottom - 180 + 'px';
				} else {
					stickyEle.style.top = 60;
				}
			});
		}
	}
	customElements.define('sticky-tabs', StickyTabs);
}